<template>
  <div>
    <Form inline>
      <FormItem>
        <Upload action="//upload.qiniup.com" name="file" :format="['jpg','jpeg','png']" ref="uploadFile" :data="uploadParams" :before-upload="beforeUpload" :on-progress="(event, file, fileList) => { uploadingFile(file) }" :on-success="uploadSuccess" :on-error="uploadError" multiple :show-upload-list="false">
          <Button type="primary" icon="ios-cloud-upload-outline">选择文件</Button>
        </Upload>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="submitUpload">确定上传</Button>
      </FormItem>
    </Form>
    <div v-show="uploadFileList.length > 0" class="upload-file-list">
      <Row class-name="file-item">
        <Col span="9">Filename</Col>
        <Col span="5">Size</Col>
        <Col span="10">Detail</Col>
      </Row>
      <Row class-name="file-item" v-for="(file, index) in uploadFileList" :key="`${file.size}-${index}`">
        <Col span="9">{{file.name}}</Col>
        <Col span="5">{{file.size | filterSize}}</Col>
        <Col span="10">
          <Progress :percent="file.progress"></Progress>
        </Col>
      </Row>
    </div>
    <div class="room-imgs">
      <Card v-for="url in finishedFileList" :key="url" style="width: 280px;margin-right: 10px;position: relative;" :padding="20">
        <img width="240px" height="180px" :src="url" />
        <div class="btn-groups">
          <Button type="primary" shape="circle" icon="arrow-left-b"></Button>
          <Button type="primary" shape="circle" icon="home"></Button>
          <Button type="primary" shape="circle" icon="trash-a"></Button>
          <Button type="primary" shape="circle" icon="arrow-right-b"></Button>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
  },
  data() {
    return {
      uploadFileList: [],
      uploadParams: {
        token: '',
      },
      finishedFileList: []
    }
  },
  methods: {
    // 图片上传前
    beforeUpload(file) {

      this.uploadFileList.push(file);
      return false;
    },
    async submitUpload() {
      // TODO: 测试
      const token = (await API.omsAPI[this.env].common.getUploadToken(false, this.token)).data;
      this.uploadParams.token = token;

      this.uploadFileList.forEach(file => {
        if (!file.progress) {
          this.$refs.uploadFile.post(file);
        }
      });
    },
    uploadingFile(file) {
      for (let i = 0; i < this.uploadFileList.length; i++) {
        if (this.uploadFileList[i].name == file.name && this.uploadFileList[i].size === file.size) {

          // 更新
          this.$nextTick(() => {
            this.uploadFileList[i].progress = parseInt(file.percentage);
            this.uploadFileList.splice(i, 1, this.uploadFileList[i]);
          })
          break;
        }
      }

    },
    uploadSuccess(resp) {
      console.info(resp);
      this.finishedFileList.push(resp.materialBase.url);
    },
    uploadError(e, error) {
      console.info(e, error);
    },
  },
  filters: {
    filterSize(size) {
      if (size < 1024) {
        return `${size}B`
      }

      const newSize = parseFloat(size / 1024);
      if (newSize < 1024) {
        return `${newSize.toFixed(2)}KB`;
      }

      return `${(newSize / 1024).toFixed(2)}MB`
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-file-list{
  .file-item{
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
  }
}
.room-imgs{
  display: flex;
  flex-wrap: wrap;
  .ivu-card-body{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
.btn-groups{
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  padding: 0 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/room/room-detail/material.vue